export const getMonthName = (date) => {
    switch (date) {
        case "01":
            return "GEN";
        case "02":
            return "FEB";
        case "03":
            return "MAR";
        case "04":
            return "APR";
        case "05":
            return "MAG";
        case "06":
            return "GIU";
        case "07":
            return "LUG";
        case "08":
            return "AGO";
        case "09":
            return "SET";
        case "10":
            return "OTT";
        case "11":
            return "NOV";
        case "12":
            return "DIC";

        default:
            return "GEN";
    }
};
